import WebCard from './WebCard';

export default {
  tag: 'web-card',
  format: '',
  sourcePipeline: (source: string) => source,
  componentFn: (node: any) => {
    return <WebCard href={node.href}>{node.children}</WebCard>;
  },
};
